import { render } from "./Ibayaq.vue?vue&type=template&id=932a9380"
import script from "./Ibayaq.vue?vue&type=script&lang=js"
export * from "./Ibayaq.vue?vue&type=script&lang=js"

import "./Ibayaq.vue?vue&type=style&index=0&id=932a9380&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__